import { render, staticRenderFns } from "./animalFixedPlugin1.vue?vue&type=template&id=97bc071e&scoped=true&"
import script from "./animalFixedPlugin1.vue?vue&type=script&lang=js&"
export * from "./animalFixedPlugin1.vue?vue&type=script&lang=js&"
import style0 from "./animalFixedPlugin1.vue?vue&type=style&index=0&id=97bc071e&prod&lang=scss&scoped=true&"
import style1 from "./animalFixedPlugin1.vue?vue&type=style&index=1&id=97bc071e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bc071e",
  null
  
)

export default component.exports